import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardTitle, Button, Input } from "reactstrap";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import plus from "../../../assets/images/plus.svg";
import tick from "../../../assets/images/tick.svg";
import { useSelector } from "react-redux";

const GymCheckList = ({ seletedGymId }) => {
  const [gymStats, setGymStats] = useState(null);
  const { appRole, userPermissions } = useSelector(
    (state) => state.auth.currentUser
  );
  const fetchlist = async () => {
    const resp = await get(`${endpoints.gym}/checklist/${seletedGymId}`);

    if (resp?.data?.success) {
      setGymStats(resp.data.data);
    } else {
      setGymStats(null);
    }
  };
  useEffect(() => {
    if (seletedGymId != "") fetchlist();
  }, [seletedGymId]);
  return (
    (userPermissions?.gym?.["Create Gym"] ||
      userPermissions?.gym?.["Update Gym"] ||
      userPermissions?.passes?.["Create Pass"] ||
      userPermissions?.passes?.["Update Pass"]) && (
      <Card
        className="rounded-4 mb-2"
        style={{ minHeight: "300px", marginBottom: 0 }}
      >
        {seletedGymId != undefined && (
          <CardBody className="d-flex flex-column ff-sora h-100">
            <div>
              <CardTitle
                tag="h5"
                className="ff-sora font-size-16 primary-black fw-normal"
              >
                Gym CheckList
              </CardTitle>
              <p className="light-black ff-sora font-size-14 fw-normal mb-0">
                Complete your checklist for seamless Payout
              </p>
            </div>
            <div className="d-flex justify-content-between  flex-nowrap">
              <div className="w-100 ">
                {userPermissions?.gym?.["Create Gym"] && (
                  <div
                    className="bg-light rounded-4 px-4 my-2"
                    style={{
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {gymStats?.verify == true ? (
                      <div
                        className="d-flex justify-content-between"
                        style={{ flex: 1 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={true}
                            style={{ marginRight: 8 }}
                          />

                          <span style={{ marginRight: "8px" }}>{"1."}</span>
                          <span>Verify Your Gym </span>
                        </div>
                        <div>
                          <img
                            src={tick}
                            alt="Search"
                            className="light-black"
                            style={{
                              height: "10px",
                              width: "10px",
                              marginRight: "5px",
                            }}
                          />
                          <span
                            className="ff-sora font-size-16 fw-bold "
                            style={{ color: "#9e9e9e" }}
                          >
                            Verify
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex justify-content-between"
                        style={{ flex: 1 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={false}
                            style={{ marginRight: 8 }}
                            readOnly
                          />
                          <span style={{ marginRight: "8px" }}>{"1."}</span>
                          <span>Verify Your Gym</span>
                        </div>
                        <Link
                          to={`/add-businessverification/:id`}
                          state={{ gymId: seletedGymId }}
                          className="ff-sora font-size-16 fw-bold"
                          style={{ color: "#3BABA6" }}
                        >
                          <img
                            src={plus}
                            alt="Search"
                            className="light-black"
                            style={{
                              height: "10px",
                              width: "10px",
                              marginRight: "5px",
                            }}
                          />
                          Verify
                        </Link>
                      </div>
                    )}
                  </div>
                )}
                {userPermissions?.gym?.["Update Gym"] && (
                  <div
                    className="bg-light rounded-4 px-4 my-2"
                    style={{
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {gymStats?.logo == true ? (
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ flex: 1 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={true}
                            style={{ marginRight: 8 }}
                          />

                          <span style={{ marginRight: "8px" }}>{"2."}</span>
                          <span>Add Logo</span>
                        </div>

                        <div>
                          <img
                            src={tick}
                            alt="Search"
                            className="light-black"
                            style={{
                              height: "10px",
                              width: "10px",
                              marginRight: "5px",
                            }}
                          />
                          <span
                            className="ff-sora font-size-16 fw-bold "
                            style={{ color: "#9e9e9e" }}
                          >
                            Add Logo
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex justify-content-between"
                        style={{ flex: 1 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={false}
                            style={{ marginRight: "8px" }}
                          />
                          <span style={{ marginRight: "8px" }}>{"2."}</span>
                          <span>Add Logo</span>
                        </div>
                        <Link
                          to={`/edit-gyms/${seletedGymId}`}
                          state={{ gymId: seletedGymId }}
                          className="ff-sora font-size-16 fw-bold"
                          style={{ color: "#3BABA6" }}
                        >
                          <img
                            src={plus}
                            alt="Search"
                            className="light-black"
                            style={{
                              height: "10px",
                              width: "10px",
                              marginRight: "5px",
                            }}
                          />
                          Add Logo
                        </Link>
                      </div>
                    )}
                  </div>
                )}
                {(userPermissions?.passes?.["Create Pass"] ||
                  userPermissions?.passes?.["Update Pass"]) && (
                  <div
                    className="bg-light rounded-4 px-4 my-2"
                    style={{
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {gymStats?.pass == true ? (
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ flex: 1 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={true}
                            style={{ marginRight: 8 }}
                          />

                          <span style={{ marginRight: "8px" }}>{"3."}</span>
                          <span>Add Pass to earn more</span>
                        </div>

                        <div>
                          <img
                            src={tick}
                            alt="Search"
                            className="light-black"
                            style={{
                              height: "10px",
                              width: "10px",
                              marginRight: "5px",
                            }}
                          />
                          <span
                            className="ff-sora font-size-16 fw-bold "
                            style={{ color: "#9e9e9e" }}
                          >
                            Add Pass
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex justify-content-between"
                        style={{ flex: 1 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={false}
                            style={{ marginRight: "8px" }}
                          />
                          <span style={{ marginRight: "8px" }}>{"3."}</span>
                          <span>Add Pass to earn more</span>
                        </div>
                        <Link
                          to={`/add-passes?gymId=${seletedGymId}`}
                          className="ff-sora font-size-16 fw-bold"
                          style={{ color: "#3BABA6" }}
                        >
                          <img
                            src={plus}
                            alt="Search"
                            className="light-black"
                            style={{
                              height: "10px",
                              width: "10px",
                              marginRight: "5px",
                            }}
                          />
                          Add Pass
                        </Link>
                      </div>
                    )}
                  </div>
                )}
                {userPermissions?.gym?.["Update Gym"] && (
                  <div
                    className="bg-light rounded-4 px-4 my-2"
                    style={{
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {gymStats?.bank == true ? (
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ flex: 1 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={true}
                            style={{ marginRight: 8 }}
                          />

                          <span style={{ marginRight: "8px" }}>{"4."}</span>
                          <span>Add Bank detail for Payout</span>
                        </div>
                        <div>
                          <img
                            src={tick}
                            alt="Search"
                            className="light-black"
                            style={{
                              height: "10px",
                              width: "10px",
                              marginRight: "5px",
                            }}
                          />
                          <span
                            className="ff-sora font-size-16 fw-bold "
                            style={{ color: "#9e9e9e" }}
                          >
                            Add Bank detail
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex justify-content-between"
                        style={{ flex: 1 }}
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={false}
                            style={{ marginRight: "8px" }}
                          />
                          <span style={{ marginRight: "8px" }}>{"4."}</span>
                          <span>Add Bank detail for Payout</span>
                        </div>
                        <Link
                          to={`/add-bank?gymId=${seletedGymId}`}
                          className="ff-sora font-size-16 fw-bold"
                          style={{ color: "#3BABA6" }}
                        >
                          <img
                            src={plus}
                            alt="Search"
                            className="light-black"
                            style={{
                              height: "10px",
                              width: "10px",
                              marginRight: "5px",
                            }}
                          />
                          Add Bank
                        </Link>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </CardBody>
        )}
      </Card>
    )
  );
};

export default GymCheckList;
